/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} No_ActivityInputs */

const en_no_activity = /** @type {(inputs: No_ActivityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No high-risk activity detected in this sector.`)
};

const id_no_activity = /** @type {(inputs: No_ActivityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tidak ada aktivitas berisiko tinggi yang terdeteksi di sektor ini.`)
};

/** @type {(inputs: No_ActivityInputs) => LocalizedString} */
const es_no_activity = en_no_activity;

/** @type {(inputs: No_ActivityInputs) => LocalizedString} */
const fr_no_activity = en_no_activity;

/** @type {(inputs: No_ActivityInputs) => LocalizedString} */
const de_no_activity = en_no_activity;

/** @type {(inputs: No_ActivityInputs) => LocalizedString} */
const ja_no_activity = en_no_activity;

/** @type {(inputs: No_ActivityInputs) => LocalizedString} */
const zh_no_activity = en_no_activity;

/** @type {(inputs: No_ActivityInputs) => LocalizedString} */
const ar_no_activity = en_no_activity;

/** @type {(inputs: No_ActivityInputs) => LocalizedString} */
const it_no_activity = en_no_activity;

/** @type {(inputs: No_ActivityInputs) => LocalizedString} */
const ru_no_activity = en_no_activity;

/** @type {(inputs: No_ActivityInputs) => LocalizedString} */
const pt_no_activity = en_no_activity;

/** @type {(inputs: No_ActivityInputs) => LocalizedString} */
const ko_no_activity = en_no_activity;

/**
* | output |
* | --- |
* | "No high-risk activity detected in this sector." |
*
* @param {No_ActivityInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const no_activity = /** @type {((inputs?: No_ActivityInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<No_ActivityInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_no_activity(inputs)
	if (locale === "es") return es_no_activity(inputs)
	if (locale === "fr") return fr_no_activity(inputs)
	if (locale === "de") return de_no_activity(inputs)
	if (locale === "ja") return ja_no_activity(inputs)
	if (locale === "zh") return zh_no_activity(inputs)
	if (locale === "ar") return ar_no_activity(inputs)
	if (locale === "id") return id_no_activity(inputs)
	if (locale === "it") return it_no_activity(inputs)
	if (locale === "ru") return ru_no_activity(inputs)
	if (locale === "pt") return pt_no_activity(inputs)
	return ko_no_activity(inputs)
});